import { checkPermission } from '@/router/guards.ts'

const CustomerReportsModule = () => import('./CustomerReportsModule.vue')
const CustomersReportIndex = () => import('./views/CustomersReportIndex.vue')
const CustomerEnrollmentReportIndex = () => import('./views/CustomersEnrollmentReportIndex.vue')
const CustomersTopPurchaseReportIndex = () => import('./views/CustomersTopPurchaseReportIndex.vue')

export const customerReportsRoute = {
  path: '/report',
  component: CustomerReportsModule,
  meta: {
    title: 'Customers Report',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: 'customers',
      name: 'customers-report-index',
      component: CustomersReportIndex,
      meta: {
        permission: 'report.customers',
      },
      beforeEnter: checkPermission('report.customers'),
    },
    {
      path: 'customers/enrollment',
      name: 'customer-enrollment-report-index',
      component: CustomerEnrollmentReportIndex,
      meta: {
        permission: 'report.customer_enrollment',
      },
      beforeEnter: checkPermission('report.customer_enrollment'),
    },
    {
      path: 'customers/top-purchase',
      name: 'customer-top-purchase-report-index',
      component: CustomersTopPurchaseReportIndex,
      meta: {
        permission: 'report.customers_top_purchase',
      },
      beforeEnter: checkPermission('report.customers_top_purchase'),
    },
  ],
}
